import React, { useEffect } from "react";
import { withStyles, createStyles, WithStyles, Theme } from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Fab from "@material-ui/core/Fab";
import Paper from "@material-ui/core/Paper";

import IconShare from "@material-ui/icons/Share";
import IconChevronRight from "@material-ui/icons/ChevronRight";
import IconAssignment from "@material-ui/icons/Assignment";

import numeral from "numeral";

import { ComboSelection } from "../lib/components/ComboSelection";
import { GradeByBit } from "../lib/components/Grading";
import { Confirmation } from "../lib/components/confirmation";

import { genericApi } from "../lib/genericAPI";
import { inspectiontype } from "../lib/storage/inspection";
import { piordergroupedtype } from "../lib/storage/piordergrouped";
import { piinstructiontype } from "../lib/storage/piinstructions";

import Instructiongrouped from "../instruction/instructiongrouped";
import InspectionPHTreatment from "./inspectionphtreatment";
import InspectionPHLabel from "./inspectionphlabel";
import InspectionFacility from "./inspectionfacility";
import InspectionInternals from "./inspectioninternals";
import InspectionJuice from "./inspectionjuice";
import InspectionLabTest from "./inspectionlabtest";

import { inspectionlabelreqtype } from "../lib/storage/inspectionlabelrequirements";
import { specialmarkettype } from "../lib/storage/specialmarket";
import { targetmarkettype } from "../lib/storage/targetmarket";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      paddingLeft: `${theme.spacing.unit * 2}px`,
      paddingRight: `${theme.spacing.unit * 2}px`,
      width: "100%",
      boxSizing: "border-box",
    },
    root: {
      width: "100%",
    },
    grid: {
      padding: theme.spacing.unit,
    },
    comboselectionform: {
      float: "left",
      display: "grid",
      width: "100%",
    },
    button: {
      padding: theme.spacing.unit / 2,
      width: "100%",
    },
    buttonWrapper: {
      width: "100%",
      marginTop: theme.spacing.unit,
    },
    paper: {
      padding: theme.spacing.unit,
      width: "300px",
    },
    instructionButton: {
      width: "100%",
      padding: `${theme.spacing.unit * 1.25}px ${theme.spacing.unit * 1.5}px`,
      textTransform: "none",
      lineHeight: 1.35,
      fontSize: "0.95rem",
      fontWeight: 500,
      justifyContent: "flex-start",
      textAlign: "center",
      marginBottom: `${theme.spacing.unit}px`,
    },
    instructionContent: {
      display: "flex",
      flexDirection: "column",
      gap: "2px",
      flex: 1,
      minWidth: 0,
      wordBreak: "break-word",
    },
    instructionPlaceholder: {
      display: "flex",
      alignItems: "center",
      gap: `${theme.spacing.unit}px`,
    },
    tableCellLabel: {
      textAlign: "right",
      fontSize: "14px",
      padding: "0px",
      width: "120px",
    },
    tableCellButton: {
      fontSize: "13px",
      padding: `${theme.spacing.unit / 2}px ${theme.spacing.unit}px`,
      textAlign: "left",
      justifyContent: "space-between",
      textTransform: "uppercase",
      fontWeight: 600,
      letterSpacing: "0.03em",
      minHeight: 36,
      color: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      backgroundColor: "rgba(25, 118, 210, 0.04)",
      "&:hover": {
        backgroundColor: "rgba(25, 118, 210, 0.08)",
        borderColor: theme.palette.primary.dark,
      },
    },
    rowLabel: {
      fontSize: "13px",
      fontWeight: 600,
      letterSpacing: "0.03em",
      textTransform: "uppercase",
      color: theme.palette.text.secondary,
      margin: 0,
      paddingLeft: `${theme.spacing.unit}px`,
    },
    rowDetail: {
      width: "100%",
      display: "grid",
      gridTemplateColumns: "120px 1fr",
      alignItems: "center",
      gap: `${theme.spacing.unit * 2}px`,
      paddingTop: `${theme.spacing.unit / 2}px`,
      paddingBottom: `${theme.spacing.unit / 2}px`,
      borderBottom: `1px solid ${theme.palette.divider}`,
      "&:last-child": {
        borderBottom: "none",
      },
    },
    marketContainer: {
      display: "flex",
      flexDirection: "row",
      gap: `${theme.spacing.unit * 2}px`,
      marginTop: theme.spacing.unit,
      marginBottom: `${theme.spacing.unit}px`,
      width: "100%",
      "& > *": {
        flex: 1,
        minWidth: 0,
      },
    },
    detailsCard: {
      width: "100%",
      padding: `0 ${theme.spacing.unit * 1.5}px`,
      marginTop: theme.spacing.unit / 2,
    },
    wrapper: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
    },
    metricValue: {
      fontSize: "1rem",
      fontWeight: 700,
      color: "#ed6c02",
      paddingLeft: theme.spacing.unit / 2,
      display: "inline-flex",
      alignItems: "baseline",
      gap: `${theme.spacing.unit / 2}px`,
    },
    metricRatio: {
      color: theme.palette.error.main,
    },
  });

type Inspection2Props = {
  inspectionid: string;
} & WithStyles<typeof styles>;

const Inspection2Unstyled: React.SFC<Inspection2Props> = (props) => {
  const { classes, inspectionid } = props;

  const [showInstructionSelection, setShowInstructionSelection] = React.useState(false);
  const [selectedOrderDetail, setSelectedOrderDetail] = React.useState([]);
  const [targetmarketsDataFiltered, setTargetmarketsDataFiltered] = React.useState([]);
  const [targetcountriesDataFiltered, setTargetcountriesDataFiltered] = React.useState([]);
  const [phlabelView, setPhlabelView] = React.useState(false);
  const [facilityView, setFacilityView] = React.useState(false);
  const [labtestView, setLabtestView] = React.useState(false);
  const [requireConsignee, setRequireConsignee] = React.useState(false);
  const [requireCountry, setRequireCountry] = React.useState(false);
  const [inspectionLabelRequirements, setInspectionLabelRequirements] = React.useState([]);
  const [ordersHaveBeenInspected, setOrdersHaveBeenInspected] = React.useState(false);
  const [confirmReset, setConfirmReset] = React.useState(false);
  const [groupnumber, setGroupnumber] = React.useState("");

  const [state, setState] = React.useState({
    producer: undefined,
    packedmarket: undefined,
    packedcountry: undefined,
    postharvestlabel: undefined,
    postharvesttreatment: undefined,
    labelconsignee: undefined,
    labelcountry: undefined,
    piorder: undefined,
    specialmarket: undefined,
    facility: undefined,
    brix: undefined,
    acid: undefined,
    juice: undefined,
    variety_id: undefined,
    week_id: undefined,
    groupnumber: undefined,
    labtest: undefined,
    puc: undefined,
    orchard: undefined,
    variety: undefined,
    degreen: undefined,
  });

  const [internalsView, setInternalsView] = React.useState(false);
  const [juiceView, setJuiceView] = React.useState(false);

  useEffect(() => {
    loadData();
  }, [inspectionid, state.piorder]);

  const loadData = async () => {
    const inspectionLabelRequirements = genericApi<inspectionlabelreqtype>("inspectionlabelreqs");
    inspectionLabelRequirements.all().then((requirements) => {
      setInspectionLabelRequirements(requirements);

      // LOAD existing
      const inspectionsGeneric = genericApi<inspectiontype>("inspections");
      inspectionsGeneric.findBy("id", inspectionid).then((data) => {
        if (data) {
          setState({
            producer: data.producer,
            packedmarket: data.packedmarket,
            packedcountry: data.packedcountry,
            postharvestlabel: data.postharvestlabel,
            postharvesttreatment: data.postharvesttreatment,
            labelconsignee: data.labelconsignee,
            labelcountry: data.labelcountry,
            piorder: data.piorder,
            specialmarket: data.specialmarket,
            facility: data.facility,
            brix: data.brix,
            acid: data.acid,
            juice: data.juice,
            variety_id: data.variety_id,
            week_id: data.week_id,
            groupnumber: data.groupnumber,
            labtest: data.labtest,
            puc: data.puc,
            orchard: data.orchard,
            variety: data.variety_id,
            degreen: data.degreen,
          });
          loadPIOrderDetailString(data.piorder, data.specialmarket, data.packedmarket);
          loadLabelRequirements(data.packedmarket, data.packedcountry, requirements);
          if (data.inspectionOrders && data.inspectionOrders.length > 0) {
            setOrdersHaveBeenInspected(true);
          }
          if (data.groupnumber) {
            setGroupnumber(data.groupnumber);
          }
        }
      });
    });
  };

  const handleChange = (name) => async (value) => {
    let newState = { ...state, [name]: value };
    setState(newState);

    if (name == "piorder") {
      setShowInstructionSelection(false);
      loadPIOrderDetailString(newState.piorder, undefined, undefined);
    }

    if (name == "specialmarket") {
      loadPIOrderDetailString(newState.piorder, value, newState.packedmarket);
    }

    if (name == "packedmarket") {
      newState = { ...newState, packedcountry: undefined };
      newState = { ...newState, labelconsignee: 2, labelcountry: 2 };
      const newStatePackedUpdate = { ...newState, proposedmarket: value };
      setState(newStatePackedUpdate);
      loadLabelRequirements(value, newState.packedcountry, inspectionLabelRequirements);
      filterTargetsCountry(newState.piorder, newState.packedmarket);
    }

    if (name == "packedcountry") {
      loadLabelRequirements(newState.packedmarket, newState.packedcountry, inspectionLabelRequirements);
    }

    const inspectionsGeneric = genericApi<inspectiontype>("inspections");
    inspectionsGeneric.findBy("id", inspectionid).then((data) => {
      const newData = {
        packedmarket: newState.packedmarket,
        packedcountry: newState.packedcountry,
        postharvestlabel: newState.postharvestlabel,
        postharvesttreatment: newState.postharvesttreatment,
        labelconsignee: newState.labelconsignee,
        labelcountry: newState.labelcountry,
        piorder: newState.piorder,
        facility: newState.facility,
        brix: newState.brix,
        acid: newState.acid,
        juice: newState.juice,
        specialmarket: newState.specialmarket,
        labtest: newState.labtest,
        degreen: newState.degreen,
      };
      inspectionsGeneric.update(inspectionid, { ...data, ...newData }).then(() => {
        inspectionsGeneric.findBy("id", inspectionid).then((data) => {});
      });
    });
  };

  const loadPIOrderDetailString = (piorder, specialmarket, packedmarket) => {
    const piordergroupedGeneric = genericApi<piordergroupedtype>("piordergrouped");
    piordergroupedGeneric.findBy("orgid", piorder).then((data) => {
      if (data) {
        const detailstring = `${data.ordernum}`;
        setSelectedOrderDetail(detailstring.split("#"));
        if (packedmarket) {
          filterTargetsCountry(data.orgid, packedmarket);
        }
        if (specialmarket) {
          filterTargetsMarket(data.orgid, specialmarket);
        }
      }
    });
  };

  const loadLabelRequirements = (packedmarket, packedcountry, requirements) => {
    const exist = requirements.find((req) => req.market == packedmarket && req.country == packedcountry);
    if (exist) {
      setRequireConsignee(exist.requiredconsignee);
      setRequireCountry(exist.requiredcountry);
    } else {
      setRequireConsignee(false);
      setRequireCountry(false);
    }
  };

  const handleOnDialogOpen = () => {
    if (ordersHaveBeenInspected) {
      setConfirmReset(true);
    } else if (groupnumber) {
      setConfirmReset(true);
    } else {
      setShowInstructionSelection(true);
    }
  };

  const handleOnDialogClose = () => {
    setShowInstructionSelection(false);
  };

  const handlePHLabelClick = () => {
    setPhlabelView(true);
  };

  const handlePHLabelClickClose = () => {
    handleChange("postharvestlabel")("0");
    setPhlabelView(false);
  };

  const handlePHLabelClickConfirm = () => {
    handleChange("postharvestlabel")("1");
    setPhlabelView(false);
  };

  const handleFacilityClick = () => {
    setFacilityView(true);
  };

  const handleFacilityClickClose = () => {
    handleChange("facility")("0");
    setFacilityView(false);
  };

  const handleFacilityClickConfirm = () => {
    handleChange("facility")("1");
    setFacilityView(false);
  };

  const handleLabTestClick = () => {
    setLabtestView(true);
  };

  const handleLabTestAction = (value: number) => {
    handleChange("labtest")(value);
    setLabtestView(false);
  };

  const filterTargetsMarket = (piorderid, specialmarket) => {
    const piinstructionsGeneric = genericApi<piinstructiontype>("piinstructions");
    piinstructionsGeneric.all().then((piinstructionsLocal) => {
      const resultFilteredMarket = [];
      piinstructionsLocal
        .filter((item) => item.orgid == piorderid)
        .map((item) => {
          const resultexist = resultFilteredMarket.find((exist) => exist.target_market == item.target_market);
          if (!resultexist) {
            resultFilteredMarket.push(item);
          }
        });

      if (resultFilteredMarket && resultFilteredMarket.length > 0) {
        const reduceTM = resultFilteredMarket
          .reduce((unique, item) => (unique.includes(item.target_market) ? unique : [...unique, item.target_market]), [])
          .sort((a, b) => {
            if (a > b) return 1;
            if (a < b) return -1;
            return 1;
          });

        if (reduceTM) {
          if (specialmarket && specialmarket == 1) {
            const specialmarketsGeneric = genericApi<specialmarkettype>("specialmarkets");
            specialmarketsGeneric.all().then((specialmarketsLocal) => {
              const reduceTMSpecial = [];
              reduceTM.map((reduceTMItem) => {
                if (specialmarketsLocal.findIndex((item) => item.market == reduceTMItem) >= 0) {
                  reduceTMSpecial.push(reduceTMItem);
                }
              });
              setTargetmarketsDataFiltered(reduceTMSpecial);
            });
          } else {
            setTargetmarketsDataFiltered(reduceTM);
          }
        }
      } else {
        setTargetmarketsDataFiltered([]);
      }
    });
  };

  const filterTargetsCountry = (piorderid, market) => {
    const piinstructionsGeneric = genericApi<piinstructiontype>("piinstructions");
    piinstructionsGeneric.all().then((piinstructionsLocal) => {
      const resultFilteredCountry = [];
      piinstructionsLocal
        .filter((item) => item.orgid == piorderid && item.target_market == market)
        .map((item) => {
          const resultexist = resultFilteredCountry.find((exist) => exist.target_country == item.target_country);
          if (!resultexist) {
            resultFilteredCountry.push(item);
          }
        });
      setTargetcountriesDataFiltered(resultFilteredCountry.map((item) => item.target_country));
    });
  };

  const handleInternalsClick = () => {
    setInternalsView(true);
  };

  const handleInternalsClickClose = () => {
    setInternalsView(false);
  };

  const handleInternalsClickConfirm = () => {
    setInternalsView(false);
    loadData();
  };

  const handleJuiceClick = () => {
    setJuiceView(true);
  };

  const handleJuiceClickClose = () => {
    setJuiceView(false);
  };

  const handleJuiceClickConfirm = () => {
    setJuiceView(false);
    loadData();
  };

  const handleResetConfirmClose = () => {
    setConfirmReset(false);
  };

  const handleResetConfirmAccept = () => {
    const inspectionsGeneric = genericApi<inspectiontype>("inspections");
    inspectionsGeneric.findBy("id", inspectionid).then((data) => {
      const newData = {
        inspectionOrders: undefined,
        actions: undefined,
        brix: 0,
        acid: 0,
        facility: undefined,
        postharvestlabel: undefined,
        postharvesttreatment: undefined,
        labelconsignee: undefined,
        labelcountry: undefined,
        juice: 0,
        groupnumber: undefined,
        labtest: undefined,
      };
      inspectionsGeneric.update(inspectionid, { ...data, ...newData }).then(() => {
        setShowInstructionSelection(true);
        loadData();
      });
    });
    setOrdersHaveBeenInspected(false);
    setConfirmReset(false);
  };

  const handleOpenExternalWebsite = () => {
    window.open("https://icaonline.co.za", "_newtab");
  };

  const hasSelectedInstruction = selectedOrderDetail && selectedOrderDetail.length > 0;
  return (
    <div className={classes.container}>
      <div className={classes.buttonWrapper}>
        <Button variant="contained" color="primary" className={classes.instructionButton} onClick={handleOnDialogOpen}>
          {hasSelectedInstruction ? (
            <div className={classes.instructionContent}>
              {selectedOrderDetail.map((item, idx) => (
                <span key={idx}>{item}</span>
              ))}
            </div>
          ) : (
            <span className={classes.instructionPlaceholder}>
              <IconAssignment fontSize="small" />
              select instruction
            </span>
          )}
        </Button>
      </div>
      {showInstructionSelection && (
        <Instructiongrouped
          handleSelectionClose={handleOnDialogClose}
          handleSelectInstruction={handleChange("piorder")}
          producerid={state.producer}
          variety_id={state.variety_id}
          week_id={state.week_id}
        />
      )}
      <div className={classes.marketContainer}>
        <ComboSelection
          classes={classes}
          name="special market"
          selected={state.specialmarket}
          setSelected={handleChange("specialmarket")}
          data={[
            { id: 1, code: "0", name: "NO" },
            { id: 2, code: "1", name: "YES" },
          ]}
          locked={ordersHaveBeenInspected}
        />
        {state.piorder && state.specialmarket && (
          <>
            <ComboSelection
              classes={classes}
              locked={ordersHaveBeenInspected}
              name="packed market"
              selected={state.packedmarket}
              setSelected={handleChange("packedmarket")}
              data={
                ordersHaveBeenInspected
                  ? [{ id: state.packedmarket, code: state.packedmarket, name: state.packedmarket }]
                  : targetmarketsDataFiltered.map((item) => {
                      return { id: item, code: item, name: item };
                    })
              }
            />
            <ComboSelection
              classes={classes}
              locked={ordersHaveBeenInspected}
              name="packed country"
              selected={state.packedcountry}
              setSelected={handleChange("packedcountry")}
              data={
                ordersHaveBeenInspected
                  ? [{ id: state.packedcountry, code: state.packedcountry, name: state.packedcountry }]
                  : targetcountriesDataFiltered.map((item) => {
                      return { id: item, code: item, name: item };
                    })
              }
            />
          </>
        )}
      </div>

      {state.piorder && state.specialmarket && (
        <Paper elevation={1} className={classes.detailsCard}>
          <div className={classes.wrapper}>
            <div className={classes.rowDetail}>
              <Button variant="outlined" color="primary" onClick={handleLabTestClick} className={classes.tableCellButton} size={"small"}>
                <span>LAB TEST</span>
                <IconChevronRight fontSize="small" />
              </Button>
              <GradeByBit inspectionid={inspectionid} piinstruction_id={0} field="labtest" value={state.labtest} handleGradeChange={handleChange("labtest")} required={false} />
            </div>
            <div className={classes.rowDetail}>
              <Button variant="outlined" color="primary" onClick={handleInternalsClick} className={classes.tableCellButton} size={"small"}>
                <span>INTERNALS</span>
                <IconChevronRight fontSize="small" />
              </Button>
              <Typography component="div" className={classes.metricValue}>
                {`${state.brix}:${state.acid}`}
                <span className={classes.metricRatio}>{numeral(state.brix / state.acid).format("0.00")}</span>
              </Typography>
            </div>
            <div className={classes.rowDetail}>
              <Button variant="outlined" color="primary" onClick={handleJuiceClick} className={classes.tableCellButton} size={"small"}>
                <span>JUICE</span>
                <IconChevronRight fontSize="small" />
              </Button>
              <Typography component="div" className={classes.metricValue}>
                {`${state.juice} %`}
              </Typography>
            </div>
            <div className={classes.rowDetail}>
              <Button variant="outlined" color="primary" onClick={handleFacilityClick} className={classes.tableCellButton} size={"small"}>
                <span>FACILITY</span>
                <IconChevronRight fontSize="small" />
              </Button>
              <GradeByBit inspectionid={inspectionid} piinstruction_id={0} field="facility" value={state.facility} handleGradeChange={handleChange("facility")} />
            </div>
            <div className={classes.rowDetail}>
              <p className={classes.rowLabel}>DEGREEN</p>
              <GradeByBit
                inspectionid={inspectionid}
                piinstruction_id={0}
                field="degreen"
                value={state.degreen}
                handleGradeChange={handleChange("degreen")}
                required={false}
                showCameraButton={false}
              />
            </div>
            <div className={classes.rowDetail}>
              <Button variant="outlined" color="primary" onClick={handlePHLabelClick} className={classes.tableCellButton} size={"small"}>
                <span>PH LABELS</span>
                <IconChevronRight fontSize="small" />
              </Button>
              <GradeByBit
                inspectionid={inspectionid}
                piinstruction_id={0}
                field="postharvestlabel"
                value={state.postharvestlabel}
                handleGradeChange={handleChange("postharvestlabel")}
              >
                <Fab color="primary" aria-label="Add" size={"small"} style={{ marginRight: "5px" }} onClick={handleOpenExternalWebsite}>
                  <IconShare />
                </Fab>
              </GradeByBit>
            </div>
            <div className={classes.rowDetail}>
              <p className={classes.rowLabel}>CONSIGNEE LBL</p>
              <GradeByBit
                inspectionid={inspectionid}
                piinstruction_id={0}
                field="labelconsignee"
                value={state.labelconsignee}
                handleGradeChange={handleChange("labelconsignee")}
                required={requireConsignee}
              />
            </div>
            <div className={classes.rowDetail}>
              <p className={classes.rowLabel}>COUNTRY LBL</p>
              <GradeByBit
                inspectionid={inspectionid}
                piinstruction_id={0}
                field="labelcountry"
                value={state.labelcountry}
                handleGradeChange={handleChange("labelcountry")}
                required={requireCountry}
              />
            </div>
          </div>
        </Paper>
      )}
      {phlabelView && (
        <Confirmation isOpen={phlabelView} handleClose={handlePHLabelClickClose} handleConfirm={handlePHLabelClickConfirm} title={``} body={``} fullscreen={true}>
          <InspectionPHLabel market={state.packedmarket} handleClose={handlePHLabelClickClose} handleConfirm={handlePHLabelClickConfirm} />
        </Confirmation>
      )}
      {facilityView && (
        <Confirmation isOpen={facilityView} handleClose={handleFacilityClickClose} handleConfirm={handleFacilityClickConfirm} title={``} body={``} fullscreen={true}>
          <InspectionFacility
            piorderid={state.piorder}
            packedmarket={state.packedmarket}
            packedcountry={state.packedcountry}
            handleClose={handleFacilityClickClose}
            handleConfirm={handleFacilityClickConfirm}
          />
        </Confirmation>
      )}
      {internalsView && (
        <Confirmation isOpen={internalsView} handleClose={handleInternalsClickClose} handleConfirm={handleInternalsClickConfirm} title={``} body={``} fullscreen={true}>
          <InspectionInternals handleClose={handleInternalsClickClose} handleConfirm={handleInternalsClickConfirm} inspectionid={inspectionid} />
        </Confirmation>
      )}
      {juiceView && (
        <Confirmation isOpen={juiceView} handleClose={handleJuiceClickClose} handleConfirm={handleJuiceClickConfirm} title={``} body={``} fullscreen={true}>
          <InspectionJuice handleClose={handleJuiceClickClose} handleConfirm={handleJuiceClickConfirm} inspectionid={inspectionid} />
        </Confirmation>
      )}
      {labtestView && (
        <Confirmation
          isOpen={labtestView}
          handleClose={() => {
            handleLabTestAction(0);
          }}
          handleConfirm={() => {
            handleLabTestAction(1);
          }}
          title={``}
          body={``}
          fullscreen={true}
        >
          <InspectionLabTest handleAction={handleLabTestAction} producer_id={state.producer} puc_id={state.puc} orchard_id={state.orchard} variety_id={state.variety_id} />
        </Confirmation>
      )}

      {confirmReset && (
        <Confirmation
          isOpen={true}
          handleClose={handleResetConfirmClose}
          handleConfirm={handleResetConfirmAccept}
          title={`Reset Inspection`}
          body={
            groupnumber
              ? `Inspection Is part of a group. Changing the Packing Instruction will remove the inspection from the group. This will also clear any inspection details entered. Would you like to clear all data?`
              : `Inspection has already been started. Changing the Packing Instruction will reset the Inspection data. This will clear any inspection details entered. Would you like to clear all data?`
          }
        ></Confirmation>
      )}
    </div>
  );
};

export default withStyles(styles)(Inspection2Unstyled);
